import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import GridConfig from "../GridConfig";

export default class SystemReportHeaders extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'report',
            data: null,
            loading: true,
            configName: 'systemreport_headers_grid',
            moduleName: 'صورتحسابهای سامانه مودیان',
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.getData();
    }
    getData() {
        this.httpPost("/api/v1/report/system/headers", {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "companyName", caption: "نام شرکت", show: true },
                { field: "userName", caption: "کاربر اصلی", show: true },
                { field: "userMobile", caption: "شماره موبایل", show: true },
                { field: "tbill", caption: "مبلغ صورتحساب", show: true },
                { field: "number", caption: "شماره صورتحساب", show: true },
                { field: "taxId", caption: "شماره مالیاتی", show: true },
                { field: "ins", caption: "موضوع صورتحساب", show: true },
                { field: "inty", caption: "نوع صورتحساب", show: true },
                { field: "inp", caption: "الگوی صورتحساب", show: true },
                { field: "status", caption: "وضعیت", show: true },
                { field: "date", caption: "تاریخ", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'companyName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'userName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'userMobile' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'tbill' && f.show) t.push({ field: f.field, cellDataType: 'number', headerName: f.caption, cellRenderer: (props) => { return this.money(props.data.tbill) } });
            if (f.field == 'number' && f.show) t.push({ field: f.field, cellDataType: 'number', headerName: f.caption});
            if (f.field == 'taxId' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'ins' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'inty' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'inp' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'status' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'date' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return <div className="nk-content-body">
            <div className="nk-block">
                <div className="card card-bordered card-stretch">
                    <div className="card-inner-group">
                        <div className="card-inner p-0">
                            {this.getToolBar(false, { add: true, print: true, pdf: true, excell: true, remove: false, otherFilters: null })}
                            {this.renderAgGrid({
                                columnDefs: this.getColumns()
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}